













import { Component, Vue, Prop } from "vue-property-decorator";
import OperatorList from "@/Emma/OperatorList.vue";
import EventBus from "@/event-bus";
import MessageStream from './MessageStream.vue';
import { authUser } from '@/auth/User.ts';

@Component({
  components: {
    "operator-list": OperatorList,
    "message-stream": MessageStream
  }
})
export default class EmergencyView extends Vue {
  @Prop()
  emergency: any;
  selectChat: any = [];
  selectOperator: Number = 0;
  openChats: any = {};

  beforeMount() {
    var self = this;
    EventBus.$on("open-chat", (operator: any) => {
      if (!(operator.id in self.openChats)) {
        self.$http
          .get(`/emma/admin/emergencies/${self.emergency.id}/messages`, {
            params: { operator_id: operator.id }
          })
          .then(resp => {
            resp.data.forEach( (el: any) => el.is_sent = el.user_id == authUser.id );
            self.openChats[operator.id] = resp.data;
            self.selectChat = self.openChats[operator.id];
            self.selectOperator = operator.id;
          });
      } else {
        self.selectChat = self.openChats[operator.id];
        self.selectOperator = operator.id;
      }
    });

    EventBus.$on("new-message", (message: any) => {
      if (!(message.user_id in self.openChats)) {
        self.$http
          .get(`/emma/admin/emergencies/${self.emergency.id}/messages`, {
            params: { operator_id: message.user_id }
          })
          .then(resp => {
            resp.data.forEach( (el: any) => el.is_sent = el.user_id == authUser.id );
            self.openChats[message.user_id] = resp.data;
            self.selectChat = self.openChats[message.user_id];
            self.selectOperator = message.user_id;
          });
      } else {
        self.selectChat = self.openChats[message.user_id];
        self.selectOperator = message.user_id;
      }
      self.selectChat.append(message);
    })
  }
}
